import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { sanuPageMeta, sanuSchema } from 'components/common/schema'
import Template from 'components/cases/sanu'

const Sanu: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...sanuPageMeta} />
      <JsonLd data={sanuSchema} />
      <Template />
    </>
  )
}

export default Sanu
